(function (root) {
  'use strict';

  function bestOffer(subtotalCents, member, currency = 'AUD') {
    if (!Number.isSafeInteger(subtotalCents) || subtotalCents < 0) throw new TypeError('Invalid merchandise subtotal');
    if (currency !== 'AUD') return {discountCents:null, payableCents:null, status:'unverified_currency'};
    const threshold = subtotalCents >= 9900 ? 900 : subtotalCents >= 5900 ? 500 : 0;
    const membership = member === true ? Math.round(subtotalCents * 5 / 100) : 0;
    const discountCents = Math.max(threshold, membership);
    return { discountCents, payableCents: subtotalCents - discountCents };
  }

  function findVariant(variants, options) {
    if (!Array.isArray(variants) || !Array.isArray(options)) return null;
    const matches = variants.filter(function (variant) {
      return variant && Number.isSafeInteger(variant.id) && variant.id > 0 &&
        Array.isArray(variant.options) && variant.options.length === options.length &&
        variant.options.every(function (value, index) { return typeof value === 'string' && value === options[index]; });
    });
    return matches.length === 1 ? matches[0] : null;
  }

  function canOrder(state) {
    return Boolean(state && state.draftPreview === false && typeof state.currency === 'string' && /^[A-Z]{3}$/.test(state.currency) && state.priceCurrencyConfirmed === true &&
      Number.isSafeInteger(state.priceCents) && state.priceCents > 0 && state.priceConfirmed === true && state.orderingReady === true &&
      state.inventoryTracked === false && ['untracked_dispatch_confirmed', 'made_to_order'].includes(state.fulfilmentMode) &&
      state.shippingReady === true && state.taxReviewed === true && state.checkoutReady === true &&
      state.variantAvailable === true);
  }

  function isValidQuantity(value) {
    if (!(typeof value === 'string' && /^\d+$/.test(value.trim()) || typeof value === 'number')) return false;
    const quantity = Number(value);
    return Number.isSafeInteger(quantity) && quantity > 0;
  }

  function showGalleryImage(element, source, alt, srcset, sizes, note, width, height) {
    const photo = element.querySelector('[data-md-product-photo]');
    const empty = element.querySelector('[data-md-image-empty]');
    const caption = element.querySelector('[data-md-photo-note]');
    if (caption && typeof note === 'string') caption.textContent = note;
    if (photo) {
      photo.hidden = !source;
      if (source) {
        if (srcset) photo.setAttribute('srcset', srcset);
        else photo.removeAttribute('srcset');
        if (sizes) photo.setAttribute('sizes', sizes);
        else photo.removeAttribute('sizes');
        photo.src = source;
        photo.alt = alt || '';
        if (Number.isFinite(Number(width)) && Number(width) > 0) photo.setAttribute('width', String(width));
        if (Number.isFinite(Number(height)) && Number(height) > 0) photo.setAttribute('height', String(height));
      }
    }
    if (empty) empty.hidden = Boolean(source);
    element.querySelectorAll('[data-md-gallery-src]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(Boolean(source) && button.dataset.mdGallerySrc === source));
    });
  }

  function productView(variant, preference) {
    if (!variant) return { mode: 'main', image: '', imageAlt: '', photoNote: '' };
    const scene = variant.scene;
    if (preference === 'scene' && scene && scene.variantId === variant.id && typeof scene.image === 'string' && scene.image.trim()) {
      return Object.assign({}, scene, { mode: 'scene' });
    }
    return { mode: 'main', image: variant.image || '', imageAlt: variant.imageAlt || '', imageSrcset: variant.imageSrcset || '', imageSizes: variant.imageSizes || '', imageWidth: variant.imageWidth, imageHeight: variant.imageHeight, photoNote: variant.photoNote || '' };
  }

  function syncMediaControls(element, variant, mode) {
    const main = element.querySelector('[data-md-view="main"]');
    const sceneButton = element.querySelector('[data-md-view="scene"]');
    const scene = productView(variant, 'scene');
    const hasScene = scene.mode === 'scene';
    const mainView = productView(variant, 'main');
    [[main, mainView, Boolean(mainView.image)], [sceneButton, scene, hasScene]].forEach(function (entry) {
      const control = entry[0];
      if (!control) return;
      control.hidden = !entry[2];
      control.setAttribute('aria-pressed', String(entry[2] && entry[1].mode === mode));
      const thumb = control.querySelector('img');
      if (thumb && entry[2]) {
        thumb.src = entry[1].thumbnail || entry[1].image;
        thumb.alt = '';
      } else if (thumb) thumb.removeAttribute('src');
    });
    const disclosure = element.querySelector('[data-md-scene-disclosure]');
    if (disclosure) {
      disclosure.hidden = !hasScene;
      disclosure.textContent = hasScene ? scene.photoNote || '' : '';
    }
    const large = element.querySelector('[data-md-large-scene]');
    if (large) {
      large.hidden = !hasScene;
      const image = large.querySelector('img');
      const caption = large.querySelector('figcaption');
      if (image && hasScene) {
        image.src = scene.image;
        image.alt = scene.imageAlt || '';
        if (scene.imageSrcset) image.setAttribute('srcset', scene.imageSrcset);
        else image.removeAttribute('srcset');
        if (scene.imageWidth) image.setAttribute('width', String(scene.imageWidth));
        if (scene.imageHeight) image.setAttribute('height', String(scene.imageHeight));
      } else if (image) {
        image.removeAttribute('src');
        image.removeAttribute('srcset');
        image.alt = '';
      }
      if (caption) caption.textContent = hasScene ? scene.photoNote || '' : '';
    }
  }

  function mount(element) {
    if (element.dataset.mdMounted === 'true') return;
    const form = element.querySelector('[data-md-order-form]');
    const button = element.querySelector('[data-md-purchase]');
    const id = form && form.querySelector('input[name="id"]');
    const quantity = form && form.querySelector('input[name="quantity"]');
    const error = element.querySelector('[data-md-order-error]');
    let currentVariant = null;
    let firstRefresh = true;
    let preferredView = 'main';
    let previousVariantId = null;

    function disablePurchase() {
      if (button) button.disabled = true;
      if (id) { id.value = ''; id.disabled = true; }
      currentVariant = null;
    }

    disablePurchase();
    const payloadNode = element.querySelector('[data-md-variant-data]');
    let payload;
    try {
      payload = JSON.parse(payloadNode && payloadNode.textContent);
      if (!payload || !Array.isArray(payload.variants) || !payload.labels ||
        !payload.variants.every(function (variant) { return variant && typeof variant === 'object' && variant.orderState && typeof variant.orderState === 'object'; })) return;
    } catch (_) { return; }
    element.dataset.mdMounted = 'true';

    function refresh() {
      disablePurchase();
      try {
        const choices = Array.from(element.querySelectorAll('[data-md-option-group]')).map(function (group) {
          const checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        currentVariant = findVariant(payload.variants, choices);
        const price = element.querySelector('[data-md-price]');
        const contents = element.querySelector('[data-md-included]');
        const caption = element.querySelector('[data-md-photo-note]');
        const quantityNote = element.querySelector('[data-md-selected-title]');
        if (price) price.textContent = currentVariant ? currentVariant.priceText : payload.labels.unavailable;
        if (contents) contents.textContent = currentVariant && currentVariant.included ? currentVariant.included : payload.labels.includedPending;
        if (quantityNote) quantityNote.textContent = currentVariant ? currentVariant.title : '';
        element.querySelectorAll('[data-md-fact]').forEach(function (fact) {
          const value = currentVariant && currentVariant.facts && currentVariant.facts[fact.dataset.mdFact];
          fact.textContent = value || '';
          if (fact.parentElement) fact.parentElement.hidden = !value;
        });
        const variantId = currentVariant ? currentVariant.id : null;
        if (firstRefresh || variantId !== previousVariantId) {
          const view = productView(currentVariant, preferredView);
          showGalleryImage(element, view.image, view.imageAlt || payload.labels.imageAlt, view.imageSrcset, view.imageSizes, view.photoNote, view.imageWidth, view.imageHeight);
          syncMediaControls(element, currentVariant, view.mode);
          previousVariantId = variantId;
        }
        firstRefresh = false;
        const ready = Boolean(form && id && quantity && currentVariant && canOrder(currentVariant.orderState) && isValidQuantity(quantity.value));
        if (ready) {
          id.value = String(currentVariant.id);
          id.disabled = false;
          if (button) button.disabled = false;
        }
        if (error) error.hidden = ready;
        return ready;
      } catch (_) {
        disablePurchase();
        if (error) error.hidden = false;
        return false;
      }
    }

    element.addEventListener('click', function (event) {
      const viewControl = event.target.closest('[data-md-view]');
      if (viewControl && element.contains(viewControl) && !viewControl.hidden) {
        preferredView = viewControl.dataset.mdView === 'scene' ? 'scene' : 'main';
        const view = productView(currentVariant, preferredView);
        showGalleryImage(element, view.image, view.imageAlt, view.imageSrcset, view.imageSizes, view.photoNote, view.imageWidth, view.imageHeight);
        syncMediaControls(element, currentVariant, view.mode);
        return;
      }
      const thumbnail = event.target.closest('[data-md-gallery-src]');
      if (thumbnail && element.contains(thumbnail)) {
        preferredView = 'main';
        syncMediaControls(element, currentVariant, 'reference');
        showGalleryImage(element, thumbnail.dataset.mdGallerySrc, thumbnail.dataset.mdGalleryAlt || payload.labels.imageAlt, thumbnail.dataset.mdGallerySrcset, thumbnail.dataset.mdGallerySizes, thumbnail.dataset.mdGalleryNote, thumbnail.dataset.mdGalleryWidth, thumbnail.dataset.mdGalleryHeight);
      }
    });
    element.addEventListener('change', function (event) {
      if (event.target.matches('[data-md-option-group] input, input[name="quantity"]')) refresh();
    });
    if (quantity) quantity.addEventListener('input', refresh);
    if (form) form.addEventListener('submit', function (event) {
      if (!refresh()) event.preventDefault();
    });
    refresh();
  }

  function mountAll(container) {
    if (container.matches && container.matches('[data-md-product]')) mount(container);
    container.querySelectorAll('[data-md-product]').forEach(mount);
  }

  root.MDSceneProduct = { bestOffer, findVariant, canOrder, isValidQuantity, showGalleryImage, productView };
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountAll(document); });
    else mountAll(document);
    document.addEventListener('shopify:section:load', function (event) { mountAll(event.target); });
  }
})(globalThis);


